module.exports = __webpack_public_path__ + "assets/user.81651b3b.svg";